<template>
  <Visitor>
    <div class="bg-gray-100 min-h-screen">
      <main class>
        <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          <h3 class="text-2xl font-medium leading-6 text-gray-900">Formulario de Contacto</h3>
          <div class="hidden sm:block">
            <div class="py-5">
              <div class="border-t border-gray-200"></div>
            </div>
          </div>
          <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
              <div class="px-4 sm:px-0">
                <h3 class="text-lg font-medium leading-6 text-gray-900">Datos Personales</h3>
              </div>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="shadow sm:rounded-md sm:overflow-hidden">
                <div class="px-4 py-5 bg-white sm:p-6">
                  <div class="grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6">
                    <div class="sm:col-span-3">
                      <label
                        for="input_dni"
                        class="block text-sm font-medium leading-5 text-gray-700"
                      >DNI</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          id="input_dni"
                          v-model="dni"
                          @change="validateDNI"
                          class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        />
                        <div
                          class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                        >
                          <!--IconSvg solid="solid" icon="exclamation-circle" myClass="h-5 w-5 text-red-500"/-->
                          <IconSvg
                            solid="solid"
                            icon="check-circle"
                            myClass="h-5 w-5 text-green-500"
                          />
                        </div>
                      </div>
                      <small v-if="error_dni" class="text-red-600">
                        {{
                        error_dni
                        }}
                      </small>
                    </div>

                    <div class="sm:col-span-3">
                      <label
                        for="input_age"
                        class="block text-sm font-medium leading-5 text-gray-700"
                      >Edad</label>
                      <div class="mt-1 rounded-md shadow-sm">
                        <input
                          id="input_age"
                          type="number"
                          v-model="age"
                          class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        />
                      </div>
                      <small v-if="error_age" class="text-red-600">
                        {{
                        error_age
                        }}
                      </small>
                    </div>

                    <div class="sm:col-span-6">
                      <label
                        for="input_first_name"
                        class="block text-sm font-medium leading-5 text-gray-700"
                      >Nombre(s)</label>
                      <div class="mt-1 rounded-md shadow-sm">
                        <input
                          id="input_first_name"
                          v-model="first_name"
                          type="text"
                          class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        />
                      </div>
                      <small v-if="error_first_name" class="text-red-600">
                        {{
                        error_first_name
                        }}
                      </small>
                    </div>
                    <div class="sm:col-span-3">
                      <label
                        for="input_last_name_p"
                        class="block text-sm font-medium leading-5 text-gray-700"
                      >Apellido Paterno</label>
                      <div class="mt-1 rounded-md shadow-sm">
                        <input
                          id="input_last_name_p"
                          v-model="last_name_p"
                          class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        />
                      </div>
                      <small v-if="error_last_name_p" class="text-red-600">
                        {{
                        error_last_name_p
                        }}
                      </small>
                    </div>

                    <div class="sm:col-span-3">
                      <label
                        for="input_last_name_m"
                        class="block text-sm font-medium leading-5 text-gray-700"
                      >Apellido Materno</label>
                      <div class="mt-1 rounded-md shadow-sm">
                        <input
                          id="input_last_name_m"
                          v-model="last_name_m"
                          class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                        />
                      </div>
                      <small v-if="error_last_name_m" class="text-red-600">
                        {{
                        error_last_name_m
                        }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="hidden sm:block">
            <div class="py-5">
              <div class="border-t border-gray-200"></div>
            </div>
          </div>
          <div class="mt-10 sm:mt-0">
            <div class="md:grid md:grid-cols-3 md:gap-6">
              <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                  <h3 class="text-lg font-medium leading-6 text-gray-900">Datos del Servicio</h3>
                </div>
              </div>
              <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="shadow sm:rounded-md sm:overflow-hidden">
                  <div class="px-4 py-5 bg-white sm:p-6">
                    <div class="grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6">
                      <div class="sm:col-span-2">
                        <label
                          for="select_department"
                          class="block text-sm font-medium leading-5 text-gray-700"
                        >Departamento</label>
                        <div class="mt-1 rounded-md shadow-sm">
                          <select
                            id="select_department"
                            v-model="department"
                            class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                          >
                            <option disabled value>Seleccionar</option>
                            <option>Lima</option>
                            <!--option value="01">Amazonas</option
                          ><option value="02">Áncash</option
                          ><option value="03">Apurímac</option
                          ><option value="04">Arequipa</option
                          ><option value="05">Ayacucho</option
                          ><option value="06">Cajamarca</option
                          ><option value="07">Callao</option
                          ><option value="08">Cusco</option
                          ><option value="09">Huancavelica</option
                          ><option value="10">Huánuco</option
                          ><option value="11">Ica</option
                          ><option value="12">Junín</option
                          ><option value="13">La Libertad</option
                          ><option value="14">Lambayeque</option
                          ><option value="15">Lima</option
                          ><option value="16">Loreto</option
                          ><option value="17">Madre de Dios</option
                          ><option value="18">Moquegua</option
                          ><option value="19">Pasco</option
                          ><option value="20">Piura</option
                          ><option value="21">Puno</option
                          ><option value="22">San Martín</option
                          ><option value="23">Tacna</option
                          ><option value="24">Tumbes</option
                            ><option value="25">Ucayali</option-->
                          </select>
                        </div>
                        <small v-if="error_department" class="text-red-600">
                          {{
                          error_department
                          }}
                        </small>
                      </div>

                      <div class="sm:col-span-2">
                        <label
                          for="select_province"
                          class="block text-sm font-medium leading-5 text-gray-700"
                        >Provincia</label>
                        <div class="mt-1 rounded-md shadow-sm">
                          <select
                            id="select_province"
                            v-model="province"
                            class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                          >
                            <option disabled value>Seleccionar</option>
                            <option value="01">Lima</option>
                          </select>
                        </div>
                        <small v-if="error_province" class="text-red-600">
                          {{
                          error_province
                          }}
                        </small>
                      </div>

                      <div class="sm:col-span-2">
                        <label
                          for="select_district"
                          class="block text-sm font-medium leading-5 text-gray-700"
                        >Distrito</label>
                        <div class="mt-1 rounded-md shadow-sm">
                          <select
                            id="select_district"
                            v-model="district"
                            class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                          >
                            <option selected disabled value>Seleccionar</option>
                            <option>Lima</option>
                          </select>
                        </div>
                        <small v-if="error_district" class="text-red-600">
                          {{
                          error_district
                          }}
                        </small>
                      </div>

                      <div class="sm:col-span-2">
                        <label
                          for="input_address"
                          class="block text-sm font-medium leading-5 text-gray-700"
                        >Dirección (Av/Jr/Calle)</label>
                        <div class="mt-1 rounded-md shadow-sm">
                          <input
                            id="input_address"
                            v-model="address"
                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                          />
                        </div>
                        <small v-if="error_address" class="text-red-600">
                          {{
                          error_address
                          }}
                        </small>
                      </div>

                      <div class="sm:col-span-2">
                        <label
                          for="input_address_number"
                          class="block text-sm font-medium leading-5 text-gray-700"
                        >Nro.</label>
                        <div class="mt-1 rounded-md shadow-sm">
                          <input
                            id="input_address_number"
                            v-model="address_number"
                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                          />
                        </div>
                        <small v-if="error_address_number" class="text-red-600">
                          {{
                          error_address_number
                          }}
                        </small>
                      </div>

                      <div class="sm:col-span-2">
                        <label
                          for="input_address_detail"
                          class="block text-sm font-medium leading-5 text-gray-700"
                        >Piso/Dpto (ej. 1/A)</label>
                        <div class="mt-1 rounded-md shadow-sm">
                          <input
                            id="input_address_detail"
                            v-model="address_detail"
                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                          />
                        </div>
                        <small v-if="error_address_detail" class="text-red-600">
                          {{
                          error_address_detail
                          }}
                        </small>
                      </div>

                      <div class="sm:col-span-2">
                        <label
                          for="input_date"
                          class="block text-sm font-medium leading-5 text-gray-700"
                        >Fecha</label>
                        <div class="mt-1 rounded-md shadow-sm">
                          <input
                            id="input_date"
                            type="date"
                            v-model="date"
                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                          />
                        </div>
                        <small v-if="error_date" class="text-red-600">
                          {{
                          error_date
                          }}
                        </small>
                      </div>

                      <div class="sm:col-span-2">
                        <label
                          for="input_start_time"
                          class="block text-sm font-medium leading-5 text-gray-700"
                        >Hora mínima (HH:MM)</label>
                        <div class="mt-1 rounded-md shadow-sm">
                          <input
                            id="input_start_time"
                            v-model="start_time"
                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                          />
                        </div>
                        <small v-if="error_start_time" class="text-red-600">
                          {{
                          error_start_time
                          }}
                        </small>
                      </div>

                      <div class="sm:col-span-2">
                        <label
                          for="input_end_time"
                          class="block text-sm font-medium leading-5 text-gray-700"
                        >Hora máxima (HH:MM)</label>
                        <div class="mt-1 rounded-md shadow-sm">
                          <input
                            id="input_end_time"
                            v-model="end_time"
                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                          />
                        </div>
                        <small v-if="error_end_time" class="text-red-600">
                          {{
                          error_end_time
                          }}
                        </small>
                      </div>
                      <div class="sm:col-span-6">
                        <label
                          for="input_message"
                          class="block text-sm font-medium leading-5 text-gray-700"
                        >Mensaje</label>
                        <div class="mt-1 rounded-md shadow-sm">
                          <textarea
                            id="input_message"
                            v-model="message"
                            rows="4"
                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                          ></textarea>
                        </div>
                        <small v-if="error_message" class="text-red-600">
                          {{
                          error_message
                          }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="hidden sm:block">
            <div class="py-5">
              <div class="border-t border-gray-200"></div>
            </div>
          </div>
          <div class="mt-10 sm:mt-0">
            <div class="flex justify-end">
              <router-link :to="'/service/'+this.$route.params.serviceId+'/cost'">
                <span class="inline-flex rounded-md shadow-sm">
                  <button
                    type="button"
                    class="py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
                  >Cancelar</button>
                </span>
              </router-link>
              <span class="ml-3 inline-flex rounded-md shadow-sm">
                <button
                  @click="submitForm"
                  type="submit"
                  class="inline-flex justify-center py-2 px-4 mx-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-primary-600 hover:bg-primary-500 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-teal-700 transition duration-150 ease-in-out"
                >Contactar</button>
              </span>
            </div>
          </div>
        </div>
      </main>
    </div>
  </Visitor>
</template>

<script>
import axios from "axios";

import IconSvg from "../../components/IconSvg.vue";
import Visitor from "../Layouts/Visitor";

export default {
  name: "ServiceCost",
  components: {
    Visitor,
    IconSvg,
  },
  data() {
    return {
      hasError: false,
      dni: "",
      age: "",
      first_name: "",
      last_name_p: "",
      last_name_m: "",
      department: "",
      province: "",
      district: "",
      address: "",
      address_number: "",
      address_detail: "",
      date: "",
      start_time: "",
      end_time: "",
      message: "",

      error_dni: "",
      error_age: "",
      error_first_name: "",
      error_last_name_p: "",
      error_last_name_m: "",
      error_department: "",
      error_province: "",
      error_district: "",
      error_address: "",
      error_address_number: "",
      error_address_detail: "",
      error_date: "",
      error_start_time: "",
      error_end_time: "",
      error_message: "",
    };
  },
  methods: {
    validateDNI() {
      axios.get("https://api.reniec.cloud/dni/" + this.dni).then((response) => {
        console.log(response.data);
      });
    },
    submitForm() {
      this.validateSubmit();
      if (this.hasError) return;
      axios.post("api.com/").then((response) => {
        console.log(response.data);
      });
    },
    validateSubmit() {
      this.hasError = false;
      if (this.dni == "" || this.dni.length != 8) {
        this.hasError = true;
        this.error_dni = "El DNI debe tener 8 dígitos";
      } else this.error_dni = "";
      if (this.age == "" || this.age < 18 || this.age > 100) {
        this.hasError = true;
        this.error_age = "La edad debe ser mayor a 18";
      } else this.error_age = "";
      if (this.first_name == "") {
        this.hasError = true;
        this.error_first_name = "Campo obligatorio";
      } else this.error_first_name = "";
      if (this.last_name_p == "") {
        this.hasError = true;
        this.error_last_name_p = "Campo obligatorio";
      } else this.error_last_name_p = "";
      if (this.last_name_m == "") {
        this.hasError = true;
        this.error_last_name_m = "Campo obligatorio";
      } else this.error_last_name_m = "";
      if (this.department == "") {
        this.hasError = true;
        this.error_department = "Campo obligatorio";
      } else this.error_department = "";
      if (this.province == "") {
        this.hasError = true;
        this.error_province = "Campo obligatorio";
      } else this.error_province = "";
      if (this.district == "") {
        this.hasError = true;
        this.error_district = "Campo obligatorio";
      } else this.error_district = "";
      if (this.address == "") {
        this.hasError = true;
        this.error_address = "Campo obligatorio";
      } else this.error_address = "";
      if (this.address_number == "") {
        this.hasError = true;
        this.error_address_number = "Campo obligatorio";
      } else this.error_address_number = "";
      if (this.address_detail == "") {
        this.hasError = true;
        this.error_address_detail = "Campo obligatorio";
      } else this.error_address_detail = "";
      if (this.date == "") {
        this.hasError = true;
        this.error_date = "Campo obligatorio";
      } else this.error_date = "";
      if (this.start_time == "") {
        this.hasError = true;
        this.error_start_time = "Campo obligatorio";
      } else this.error_start_time = "";
      if (this.end_time == "") {
        this.hasError = true;
        this.error_end_time = "Campo obligatorio";
      } else this.error_end_time = "";
      if (this.message == "") {
        this.hasError = true;
        this.error_message = "Campo obligatorio";
      } else this.error_message = "";
    },
  },
};
</script>